/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivExceptionViewmodelGen,
  MrfiktivSendMessageResultViewModelGen,
  MrfiktivSendSmsDtoGen,
  MrfiktivSendWhatsAppDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class PhoneMessage<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Sends an SMS message to the specified phone number
   *
   * @tags Phone Message
   * @name PhoneMessageControllerSendSms
   * @summary Send an SMS message
   * @request POST:/partner/{partnerId}/phone/message/sms
   * @secure
   * @response `201` `MrfiktivSendMessageResultViewModelGen` Message sent successfully
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  phoneMessageControllerSendSms = (partnerId: string, data: MrfiktivSendSmsDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivSendMessageResultViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/phone/message/sms`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * @description Sends a WhatsApp message to the specified phone number. Requires an active session (customer must have messaged first within 24h).
   *
   * @tags Phone Message
   * @name PhoneMessageControllerSendWhatsApp
   * @summary Send a WhatsApp message
   * @request POST:/partner/{partnerId}/phone/message/whatsapp
   * @secure
   * @response `201` `MrfiktivSendMessageResultViewModelGen` Message sent successfully
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  phoneMessageControllerSendWhatsApp = (
    partnerId: string,
    data: MrfiktivSendWhatsAppDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivSendMessageResultViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/phone/message/whatsapp`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
